import { useThemeSwitch } from 'hooks/theme'
import { useAnalytics } from 'hooks/use-analytics/useAnalytics'
import { useFeedApi } from 'hooks/use-feed-api/useFeedApi'
import { useNotification } from 'hooks/use-notification/useNotification'
import { useNotifications } from 'hooks/use-notifications/useNotifications'
import { useProfilePercentage } from 'hooks/use-profile-percentage/useProfilePercentage'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { useUpdateModePreference } from 'hooks/use-update-mode-preference/useUpdateModePreference'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { usePasswordChange } from 'pages/settings/hooks/usePasswordChange'
import { PropsWithChildren, useState } from 'react'
import { useHistory, useLocation } from 'react-router'
import { useTheme } from 'styled-components'
import { IMainWrapperNavBarProps } from './MainWrapperNavBar'

export const useMainWrapperNavBar = (props: PropsWithChildren<IMainWrapperNavBarProps>) => {
  const {
    nopadding,
  } = props

  const [showInviteFriends, setShowInviteFriends] = useState(false)
  const [showFeedback, setShowFeedback] = useState<boolean>(false)
  const [overlayTabIndex, setOverlayTabIndex] = useState(0)
  const { onLogout, isAuthenticated, backendUser, backendPartner } = useAuth()
  const { isDevice, isTablet } = useScreenSizes()
  const { notify } = useNotification()
  const [openSideBar, setOpenSideBar] = useState(false)
  const history = useHistory()
  const { pathname } = useLocation()
  const { mode } = useThemeSwitch()
  const theme = useTheme()

  const {
    unreadNotifications,
    drawer,
    setDrawer,
    totalNotifications,
    setPage: setNotificationPage,
    page: notificationPage,
    updateNotification,
    setNotifications,
    setTotalNotifications,
    clearNotifications,
    showNotificationAlert,
    handleAlertClick,
    handleStoringLatestNotification,
  } = useNotifications(backendUser?.id)

  const { handleModeChange, loadingPreference } = useUpdateModePreference()
  const { getProfilePercentage } = useProfilePercentage()
  const { logEventAnalytics } = useAnalytics()

  const {
    vDetails,
    setError,
    password,
    setPassword,
    passwordValid,
    setPasswordValid,
    onResetPasswordWithUser,
    passwordChange,
    setPasswordChange,
    showChangePassword,
    setShowChangePassword,
    currentPassword,
    setCurrentPassword,
    handleErrorMessage,
    confirmPassword,
    setConfirmPassword,
    confirmPasswordValid,
    setConfirmPasswordValid,
    onCurrentPasswordChange,
    onPasswordChange,
    onConfirmPasswordChange,
  } = usePasswordChange()

  const { createFeedback } = useFeedApi()

  const handleAvatarClickTracker = (eventName: string, options?: Record<string, any>) => {
    const partnerLog = {}
    const userLog = {}
    const logData = {}
    if (options && (options['Feedback Category'] || options['Feedback Category'])) {
      logData['Feedback Category'] = options['Feedback Category']
      logData['Attached File'] = options['Attached File']
    }

    if (options && options['Mode Category']) {
      logData['Mode Category'] = options['Mode Category']
    }
    userLog['User ID'] = backendUser?.id
    userLog['Email address'] = backendUser?.username
    if (backendUser?.partnerId) {
      partnerLog['Partner ID'] = backendPartner?.id
      partnerLog['Company Name'] = backendPartner?.name
      partnerLog['Account Type'] = 'Partner'
    } else {
      userLog['Account Type'] = backendUser?.role
    }
    logEventAnalytics(
      backendUser?.partnerId ? 'Partner' : 'Member',
      eventName,
      'mixpanel',
      eventName,
      { ...partnerLog, ...userLog, ...logData },
      backendUser?.id
    )
  }

  const navbarPadding = () => {
    if ((nopadding && isDevice) || isDevice) {
      return '0 1em'
    }
    return '0'
  }

  const forceUpdate = () => {
    if (pathname === '/feed') {
      window.scrollTo(0, 0)
      window.location.reload()
    }
  }

  const toggleDrawer = open => {
    setOpenSideBar(open)
  }

  return {
    showInviteFriends,
    setShowInviteFriends,
    showFeedback,
    setShowFeedback,
    overlayTabIndex,
    setOverlayTabIndex,
    onLogout,
    isAuthenticated,
    backendUser,
    backendPartner,
    isDevice,
    isTablet,
    notify,
    openSideBar,
    setOpenSideBar,
    history,
    pathname,
    mode,
    theme,
    unreadNotifications,
    drawer,
    setDrawer,
    totalNotifications,
    setPage: setNotificationPage,
    page: notificationPage,
    updateNotification,
    setNotifications,
    setTotalNotifications,
    clearNotifications,
    showNotificationAlert,
    handleAlertClick,
    handleStoringLatestNotification,
    handleModeChange,
    loadingPreference,
    getProfilePercentage,
    logEventAnalytics,
    vDetails,
    setError,
    password,
    setPassword,
    passwordValid,
    setPasswordValid,
    onResetPasswordWithUser,
    passwordChange,
    setPasswordChange,
    showChangePassword,
    setShowChangePassword,
    currentPassword,
    setCurrentPassword,
    handleErrorMessage,
    confirmPassword,
    setConfirmPassword,
    confirmPasswordValid,
    setConfirmPasswordValid,
    onCurrentPasswordChange,
    onPasswordChange,
    onConfirmPasswordChange,
    createFeedback,
    handleAvatarClickTracker,
    navbarPadding,
    forceUpdate,
    toggleDrawer
  } as const
}